import { Link } from "react-router-dom";
import type { Video } from "@/mocks/videos";

interface VideoCardProps {
  video: Video;
}

export default function VideoCard({ video }: VideoCardProps) {
  return (
    <Link
      to={`/article/${video.id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:scale-[1.02]"
      data-product-shop=""
    >
      <div className="relative w-full aspect-video overflow-hidden">
        <img
          src={video.coverImage}
          alt={video.title}
          title={`${video.title} - 久久视频高清在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
        <span className="absolute bottom-2 right-2 bg-black/70 text-white text-xs px-2 py-0.5 rounded">
          {video.duration}
        </span>
        {video.isNew && (
          <span className="absolute top-2 left-2 bg-accent-500 text-background-50 text-xs px-2 py-0.5 rounded font-medium">
            NEW
          </span>
        )}
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
            <i className="ri-play-fill text-2xl"></i>
          </div>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-500 transition-colors">
          {video.title}
        </h3>
        <div className="flex items-center justify-between mt-2 text-xs text-foreground-500">
          <span className="bg-secondary-100 text-secondary-900 px-2 py-0.5 rounded whitespace-nowrap">
            {video.category}
          </span>
          <span>{video.platform}</span>
        </div>
        <div className="flex items-center justify-between mt-1.5 text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-500"></i>
            {video.rating}
          </span>
          <span>{video.views >= 10000 ? `${(video.views / 10000).toFixed(1)}万次` : `${video.views}次`}</span>
        </div>
      </div>
    </Link>
  );
}